import api from "@/app/api";
import { useApiCall } from "@/app/api/apiCall";
import { useSession } from "@/app/auth/SessionProvider";
import { Link } from "@/app/components/Link";
import { SubmitButton } from "@/app/components/SubmitButton";
import { Unauth } from "@/app/components/Unauth";
import { Text } from "@chakra-ui/react";
import { Form, FormLayout } from "@saas-ui/react";
import { useState } from "react";

interface LoginPayload {
  email: string;
  password: string;
}

export default function Login() {
  const { setSession } = useSession();
  const handle = useApiCall();
  const [isLoggingIn, setIsLoggingIn] = useState<boolean>(false);
  const onSubmit = async (payload: LoginPayload) => {
    setIsLoggingIn(true);
    await handle(
      () => api.getToken(payload),
      () => {
        setSession(true);
        setIsLoggingIn(false);
      },
      () => {
        setIsLoggingIn(false);
      }
    );
  };

  return (
    <Unauth
      form={
        <Form
          onSubmit={onSubmit}
          defaultValues={{
            password: undefined,
            email: undefined,
          }}
        >
          {({ Field }) => (
            <FormLayout>
              <Field
                name="email"
                label="Email address"
                disabled={isLoggingIn}
                type="text"
                rules={{
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Please enter a valid email address",
                  },
                  required: "Email address is required.",
                }}
              />
              <div>
                <Field
                  name="password"
                  disabled={isLoggingIn}
                  label="Password"
                  type="password"
                  rules={{
                    required: "Password is required.",
                  }}
                />
                <div className="flex justify-end mt-1">
                  <Link to="/forgot-password" data-cy="forgot-password-link">
                    Forgot password?
                  </Link>
                </div>
              </div>
              <SubmitButton isDisabled={isLoggingIn}>Login</SubmitButton>
            </FormLayout>
          )}
        </Form>
      }
      footer={
        <Text fontSize="xs">
          Don't have an account?{" "}
          <Link to="/sign-up" data-cy="sign-up-link">
            Sign up
          </Link>
        </Text>
      }
    />
  );
}
